/* @ngInject */
function UnauthorizedInterceptor($q, $injector) {
  return {
    responseError: function (rejection) {
      const SecurityManager = $injector.get("SecurityManager");
      const $state = $injector.get("$state");

      if (
        rejection.status === 401 &&
        !rejection.config.url.includes("/sign-out")
      ) {
        SecurityManager.signout(function () {
          $state.go("login");
        });
      }

      return $q.reject(rejection);
    },
  };
}

export default UnauthorizedInterceptor;
